module.exports = __webpack_public_path__ + "static/media/storePurchase_100_250.8e0d7342.png";